import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ListItemText from '@mui/material/ListItemText';
import { List, ListItem, ListItemButton, Typography } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import Box from '@mui/material/Box';
import { MobileMenuItemProps } from '../Interfaces';
import KeyboardArrowIcon from './KeyboardArrowIcon';
import styles from '../Header.styles';
import { ReactSVG } from 'react-svg';
import { v4 as uuidv4 } from 'uuid';

const MobileMenuItem: React.FC<MobileMenuItemProps> = ({
  linkConfig,
  isBottomMenu,
  toggleDrawer,
  onClick,
  isOpen,
  isAccountLink,
}: MobileMenuItemProps) => {
  const location = useLocation();
  const { icon, iconUrl, url, subLinks, label, externalUrl, disabled } =
    linkConfig;
  const DrawIcon = icon;

  const isLinkActive = url
    ? location.pathname.indexOf(url) >= 0
    : subLinks?.some(
        (link) => location.pathname.indexOf(link.url as string) >= 0
      );

  const highlight = isOpen || isLinkActive;

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (onClick) onClick(e);
    if (url) toggleDrawer();
  };
  const handleClose = () => {
    toggleDrawer();
  };

  return (
    <>
      <ListItem sx={styles.mobileMenuItem(isOpen, highlight)} key={uuidv4()}>
        <ListItemButton
          component={externalUrl || subLinks ? 'a' : Link}
          href={externalUrl ? url : undefined}
          to={!externalUrl ? url : undefined}
          onClick={handleClick}
          aria-controls="mobile-menu"
          aria-haspopup="true"
          aria-expanded={isOpen ? 'true' : undefined}
          disabled={disabled}
        >
          <ListItemText
            sx={styles.mobileMenuItemText}
            primary={
              <Box sx={styles.mobileMenuItemWithSubmenu(isBottomMenu)}>
                {icon && (
                  <ListItemIcon>
                    <DrawIcon />
                  </ListItemIcon>
                )}
                {iconUrl && (
                  <ListItemIcon classes={{ root: 'custom-icon' }}>
                    <ReactSVG src={iconUrl} />
                  </ListItemIcon>
                )}
                <Typography
                  variant={isAccountLink ? 'body3Medium' : 'body3Bold'}
                >
                  {label}{' '}
                </Typography>
                {subLinks?.length && (
                  <KeyboardArrowIcon
                    isOpen={isOpen}
                    style={styles.mobileSubmenuIcon}
                  />
                )}
              </Box>
            }
          />
        </ListItemButton>
        {subLinks?.length && isOpen && (
          <List sx={styles.mobileSubmenu} key={uuidv4()}>
            {subLinks.map((link) => (
              <ListItem sx={styles.mobileSubmenuItem} key={uuidv4()}>
                <ListItemButton
                  classes="sub-item-margin"
                  href={link.externalUrl ? link.url : undefined}
                  to={!link.externalUrl ? link.url : undefined}
                  component={link.externalUrl ? 'a' : Link}
                  key={link.label}
                  onClick={handleClose}
                  aria-controls="mobile-menu"
                  aria-haspopup="true"
                  aria-expanded={isOpen ? 'true' : undefined}
                >
                  <ListItemText
                    sx={styles.mobileMenuItemText}
                    primary={
                      <Typography variant="body3Medium">
                        {link.label}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </ListItem>
    </>
  );
};

export default MobileMenuItem;
